<template>
  <div class="wg-col wg-xs-12" style="padding: 2%">
    <wg-modal
      v-if="openModal"
      :width="windowWidth > 700 ? '500px' : '80%'"
      :portal="true"
      @closeModal="closeModal"
    >
      <div slot="header" class="com-anm22-app-text-xl">
        <span>{{
          mode == "edit"
            ? $anm22.strLang(lang, "Edit", "Modifica " + currentProduct.name)
            : $anm22.strLang(lang, "New", "Nuovo")
        }}</span>
      </div>

      <div slot="body">
        <span>{{ $anm22.strLang(lang, "Name", "Nome") }}</span>
        <div class="wg-col wg-xs-5">
          <input
            class="input-elem print-elem com-anm22-app-input-text"
            type="text"
            v-model="currentProduct.name"
          />
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <span>{{
          $anm22.strLang(lang, "Product code", "Codice prodotto")
        }}</span>
        <div class="wg-col wg-xs-5">
          <input
            class="input-elem print-elem com-anm22-app-input-text"
            type="text"
            v-model="currentProduct.code"
          />
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <span>{{ $anm22.strLang(lang, "Category", "Categoria") }}</span>
        <div class="wg-col wg-xs-5">
          <select
            class="input-elem print-elem com-anm22-app-select"
            v-model="currentProduct.category"
          >
            <option value="">{{
              $anm22.strLang(lang, "No category", "Nessuna categoria")
            }}</option>
            <option
              v-for="(category, index) in productCategories"
              :key="index"
              :value="category.idWarehouseCategory"
            >
              {{ category.name }}
            </option>
          </select>
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <span>{{
          $anm22.strLang(lang, "Manufacturer", "Produttore/Fornitore")
        }}</span>
        <div class="wg-col wg-xs-5">
          <input
            class="input-elem print-elem com-anm22-app-input-text"
            type="text"
            v-model="currentProduct.manufacturer"
          />
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <span>{{ $anm22.strLang(lang, "Color", "Colore") }}</span>
        <div class="wg-col wg-xs-5">
          <input
            class="input-elem print-elem com-anm22-app-input-text"
            type="text"
            v-model="currentProduct.colorString"
          />
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <span>{{
          $anm22.strLang(lang, "Stock type", "Modalità quantità")
        }}</span>
        <div class="wg-col wg-xs-5">
          <select
            class="input-elem print-elem com-anm22-app-select"
            v-model="currentProduct.stockType"
          >
            <option value="1">{{
              $anm22.strLang(lang, "Unlimited", "Illimitata")
            }}</option>
            <option value="2">{{
              $anm22.strLang(lang, "Unit", "Unità")
            }}</option>
            <option value="3">{{
              $anm22.strLang(lang, "Weight", "Peso")
            }}</option>
            <option value="4">{{
              $anm22.strLang(lang, "Volume", "Volume")
            }}</option>
            <option value="5">{{
              $anm22.strLang(lang, "Surface", "Superficie")
            }}</option>
            <option value="6">{{
              $anm22.strLang(lang, "Length", "Lunghezza")
            }}</option>
            <option value="7">{{
              $anm22.strLang(lang, "Time", "Tempo")
            }}</option>
          </select>
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <template v-if="currentProduct.stockType != 1">
          <template v-if="currentProduct.stockType != 2">
            <span>{{
              $anm22.strLang(lang, "Unit of measurement", "Unità di misura")
            }}</span>
            <div class="wg-col wg-xs-5">
              <select
                class="input-elem print-elem com-anm22-app-select"
                v-model="currentProduct.uom"
              >
                <option value="1" v-if="currentProduct.stockType == 3"
                  >kg</option
                >
                <option value="2" v-if="currentProduct.stockType == 4"
                  >l</option
                >
                <option value="3" v-if="currentProduct.stockType == 3"
                  >g</option
                >
                <option value="4" v-if="currentProduct.stockType == 3"
                  >q</option
                >
                <option value="5" v-if="currentProduct.stockType == 3"
                  >t</option
                >
                <option value="6" v-if="currentProduct.stockType == 6"
                  >m</option
                >
                <option value="7" v-if="currentProduct.stockType == 6"
                  >km</option
                >
                <option value="8" v-if="currentProduct.stockType == 5"
                  >m²</option
                >
                <option value="9" v-if="currentProduct.stockType == 4"
                  >m³</option
                >
                <option value="10" v-if="currentProduct.stockType == 7"
                  >min</option
                >
                <option value="11" v-if="currentProduct.stockType == 7"
                  >h</option
                >
                <option value="12" v-if="currentProduct.stockType == 7"
                  >d</option
                >
              </select>
              <div class="vertical-height-div" style="height: 12px"></div>
            </div>
          </template>
          <span>{{ $anm22.strLang(lang, "Quantity", "Quantità") }}</span>
          <div class="wg-col wg-xs-5">
            <input
              class="input-elem print-elem com-anm22-app-input-text"
              type="number"
              step="0.1"
              v-model="currentProduct.quantity"
            />
            <div class="vertical-height-div" style="height: 12px"></div>
          </div>
          <span>{{
            $anm22.strLang(lang, "Warning quantity", "Soglia allarme quantità")
          }}</span>
          <div class="wg-col wg-xs-5">
            <input
              class="input-elem print-elem com-anm22-app-input-text"
              type="number"
              step="0.1"
              v-model="currentProduct.defaultQuantity"
            />
            <div class="vertical-height-div" style="height: 12px"></div>
          </div>
        </template>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row">
          <input
            type="button"
            :value="$anm22.strLang(lang, 'Save', 'Salva')"
            @click="addProduct"
          />
          <input
            type="button"
            :value="$anm22.strLang(lang, 'Delete', 'Elimina')"
            class="red"
            style="margin-left:10px"
            @click="removeProduct(currentProduct)"
          />
        </div>
      </div>
    </wg-modal>
    <div style="font-size: 24px" class="com-anm22-app-text-m">
      {{ $anm22.strLang(lang, "Warehouse", "Magazzino") }}
    </div>
    <div class="vertical-height-div" style="height: 20px"></div>
    <div class="wg-row products-list-menu">
      <input
        type="button"
        :value="$anm22.strLang(lang, 'Add product', 'Aggiungi prodotto')"
        @click="add"
      />
      <WGPageControls
        :offset="pageOffset"
        :limit="pageResultsNum"
        :itemsNum="products.length"
        :language="lang"
        :prevPageClick="prevPage"
        :nextPageClick="nextPage"
        :firstPageClick="firstPage"
        :lastPageClick="lastPage"
      ></WGPageControls>
    </div>
    <div class="vertical-height-div" style="height: 20px"></div>
    <div class="products-list">
      <div class="wg-row product-row header">
        <div class="code">{{ $anm22.strLang(lang, "Code", "Codice") }}</div>
        <div class="name">{{ $anm22.strLang(lang, "Name", "Nome") }}</div>
        <div class="category">
          {{ $anm22.strLang(lang, "Category", "Categoria") }}
        </div>
        <div class="quantity">{{ $anm22.strLang(lang, "Qnt", "Qnt") }}</div>
        <div class="color"></div>
        <div class="edit"></div>
        <div class="delete"></div>
      </div>
      <div
        class="wg-row product-row"
        v-for="(product, index) in productsList.slice(
          pageOffset,
          pageOffset + pageResultsNum
        )"
        :key="index"
        @click="selectProduct(product)"
      >
        <div class="code">{{ product.code }}</div>
        <div class="name">{{ product.name }}</div>
        <div class="category">
          {{ getProductCategoryNameById(product.category) }}
        </div>
        <div class="quantity">
          {{ product.stockType == 1 ? "-" : product.quantity }}
        </div>
        <div class="color">
          <div
            class="color-preview"
            :title="product.colorString"
            :style="{ 'background-color': product.colorString }"
          ></div>
        </div>
        <div class="edit">
          <img
            :src="$anm22.icons.getWorldIcon('edit')"
            class="edit-btn"
            :title="$anm22.strLang(lang, 'Edit', 'Modifica')"
            @click="selectProduct(product)"
          />
        </div>
        <div class="delete">
          <img
            :src="$anm22.icons.getWorldIcon('deleteBin')"
            class="delete-btn"
            :title="$anm22.strLang(lang, 'Delete', 'Elimina')"
            @click.stop="removeProduct(product)"
          />
        </div>
      </div>
      <div class="empty-list-msg" v-if="!products || products.length == 0">
        {{ $anm22.strLang(lang, "No products.", "Nessun prodotto.") }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import WGPageControls from "../../../../world/spa/components/WGPageControls.vue";

export default {
  components: {
    WGPageControls,
  },
  data() {
    return {
      products: [],
      productCategories: [],
      mode: "edit",
      openModal: false,
      currentProduct: {},
      pageResultsNum: 50,
      pageOffset: 0,
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      windowWidth: (state) => state.windowWidth,
    }),
    productsList() {
      return this.products;
    },
  },
  methods: {
    searchFn(string) {
      const regexp = new RegExp(string, "i");
      let results = [];
      /* Ricerca contatti per nome */
      results = results.concat(
        this.products
          .filter((p) => {
            return -1 !== p.name.search(regexp) || -1 !== p.code.search(regexp);
          })
          .map((p) => {
            const label =
              (p.code || "") + (p.code && p.name ? " - " : "") + (p.name || "");
            return {
              label: label,
              img: this.$anm22.icons.getWorldIcon("package"),
              submitFn: () => {
                this.selectProduct(p);
              },
            };
          })
      );
      return results;
    },
    loadData() {
      this.$http
        .get("warehouse")
        .then((response) => {
          this.products = response.data.products;
          this.productCategories = response.data.categories;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    add() {
      this.currentProduct = {};
      this.openModal = true;
      this.mode = "new";
    },
    addProduct() {
      if (this.mode == "new") {
        this.$http
          .post(
            "product/new",
            {
              product: this.currentProduct,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            this.$anm22.eventBus.$emit("wg-modal-close");
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$http
          .post(
            "product/edit",
            {
              product: this.currentProduct,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            this.loadData();
            this.$anm22.eventBus.$emit("wg-modal-close");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    removeProduct(product) {
      this.$http
        .post(
          "product/delete",
          {
            product: product,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.loadData();
        })
        .catch((error) => {
          console.log(error);
        });
      this.closeModal();
    },
    selectProduct(product) {
      this.mode = "edit";
      this.openModal = true;
      this.currentProduct = product;
    },
    closeModal() {
      this.loadData();
      this.openModal = false;
    },
    getProductCategoryById(categoryId) {
      let categroy = null;
      this.productCategories.forEach(function(element) {
        if (element.idWarehouseCategory == categoryId) {
          categroy = element;
        }
      });
      return categroy;
    },
    getProductCategoryNameById(categoryId) {
      const category = this.getProductCategoryById(categoryId);
      if (category) {
        return category.name;
      } else {
        return "";
      }
    },
    nextPage() {
      if (this.pageOffset + this.pageResultsNum < this.products.length) {
        this.pageOffset += this.pageResultsNum;
      }
    },
    prevPage() {
      if (this.pageOffset > 0) {
        this.pageOffset -= this.pageResultsNum;
      }
    },
    firstPage() {
      this.pageOffset = 0;
    },
    lastPage() {
      if (this.products.length <= 0) {
        this.pageOffset = 0;
      } else {
        this.pageOffset =
          Math.floor((this.products.length - 1) / this.pageResultsNum) *
          this.pageResultsNum;
      }
    },
  },
  created() {
    this.loadData();
  },
  mounted() {
    this.$anm22.eventBus.$emit("world-headbar-search-config", {
      hintFn: this.searchFn,
    });
  },
};
</script>

<style lang="scss" scoped>
.products-list {
  overflow-x: auto;

  .product-row {
    border-radius: 8px;
    min-height: 49px;
    padding: 5px;
    flex-wrap: nowrap;
    cursor: pointer;
    max-width: 1700px;

    &:hover {
      background-color: #ffffff;
    }
    div {
      display: inline-block;
      vertical-align: top;
      white-space: normal;
      padding: 11px;

      &.code {
        flex: 1;
        width: 10%;
        min-width: 60px;
        word-wrap: break-word;
      }
      &.name {
        flex: 3;
        width: 15%;
        min-width: 120px;
      }
      &.category {
        flex: 1;
        width: 15%;
        min-width: 120px;
      }
      &.quantity {
        width: 10%;
        min-width: 60px;
      }
      &.color {
        width: 42px;

        .color-preview {
          border: 1px solid #ddd;
          border-radius: 10px;
          box-sizing: border-box;
          width: 16px;
          height: 16px;
          padding: 0;
        }
      }
      &.edit,
      &.delete {
        padding: 8px;
        width: 36px;

        .edit-btn,
        .delete-btn {
          width: 20px;
          height: 20px;
          cursor: pointer;
        }
      }
    }

    &.header {
      div {
        font-weight: 600;
      }

      &:hover {
        background: none !important;
      }
    }
  }

  .empty-list-msg {
    padding: 16px;
  }
}

.products-list-menu {
  align-items: center;
  max-width: 1700px;
}
</style>
